/* global axios */

import ApiClient from './ApiClient';

class PlatformBannersAPI extends ApiClient {
  constructor() {
    super('platform_banners', { accountScoped: false });
  }

  getActive() {
    return axios.get(this.url);
  }
}

export default new PlatformBannersAPI();
